import * as _ from 'lodash';
import { SendSPUDataRefreshEmailPayloadType } from './../../dashboard/interfaces/index';

import axiosInstance from '../../../axiosInstance';

export const sendSPUDataRefreshStatusEmail = async (
  payload: SendSPUDataRefreshEmailPayloadType,
  { dispatch }
): Promise<void> => {
  try {
    const res = await axiosInstance.post(
      `sendMail`,
      {
        ...payload?.data
      },
      {
        headers: {
          Authorization: `Bearer ${payload?.accessToken}`
        }
      }
    );
    return res?.data || {};
  } catch (err) {
    throw new Error(
      err?.response?.data?.msg || 'An error occurred while sending email.'
    );
  }
};
